import React from 'react';
import {Space} from 'antd';
import commonRefHOC from '../commonRefHOC';

export default commonRefHOC(Space);